import { AdyenBrands, PaymentMethod } from '@grandvisionhq/payments';

var AppleBrands;
(function(AppleBrands) {
    AppleBrands["DISCOVER"] = 'discover';
    AppleBrands["VISA"] = 'visa';
    AppleBrands["MASTERCARD"] = 'masterCard';
    AppleBrands["AMEX"] = 'amex';
    AppleBrands["MAESTRO"] = 'maestro';
    AppleBrands["BANCONTACTMC"] = 'bcmc';
})(AppleBrands || (AppleBrands = {}));
const BrandsMap = {
    [AdyenBrands.VISA]: AppleBrands.VISA,
    [AdyenBrands.MASTERCARD]: AppleBrands.MASTERCARD,
    [AdyenBrands.AMEX]: AppleBrands.AMEX,
    [AdyenBrands.MAESTRO]: AppleBrands.MAESTRO,
    [AdyenBrands.BANCONTACTMC]: AppleBrands.BANCONTACTMC
};
const mapCartPaymentMethods = (cartPaymentMethods)=>{
    if (cartPaymentMethods.length === 0) {
        return [];
    }
    const applePayPaymentMethod = cartPaymentMethods === null || cartPaymentMethods === void 0 ? void 0 : cartPaymentMethods.find((paymentMethod)=>{
        return (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name) === PaymentMethod.APPLE_PAY;
    });
    if (applePayPaymentMethod === null || applePayPaymentMethod === void 0 ? void 0 : applePayPaymentMethod.brands) {
        var _adyenBrand;
        return applePayPaymentMethod.brands.map((adyenBrand)=>(_adyenBrand = BrandsMap[adyenBrand]) !== null && _adyenBrand !== void 0 ? _adyenBrand : adyenBrand
        ).filter((brand)=>!!brand
        );
    }
    return [];
};

export { AppleBrands, mapCartPaymentMethods };
//# sourceMappingURL=apple-pay-payment-methods.js.map
